import React from 'react';
import styled from 'styled-components';

const BaseStyledDiv = styled.div`
  margin-left: ${(props: { isWide: boolean }) => (props.isWide ? 24 : 12)}px;
  margin-top: ${(props: { isWide: boolean }) => (props.isWide ? 10 : -8)}px;
  color: #717171;
  ${(props: { isWide: boolean }) =>
    props.isWide
      ? ``
      : `width: 100%;
    align-self: center;`}
`;

const StyledP = styled.p`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  font-size: ${(props: { isWide: boolean }) =>
    props.isWide ? '14px !important' : '14px'};
  font-weight: bold;
  color: #333333;
  ${(props: { isWide: boolean }) =>
    props.isWide
      ? `line-height: 20px;
      margin-bottom: 10px !important;`
      : `margin: 0px 0px 0px 0px;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 91%;
      word-break: break-all;
        `}
`;

interface Props {
  facilityName: string;
  inquiryCategoryName?: string;
  isWide: boolean;
}

export const ChatHeaderRecipient = (props: Props) => {
  const { facilityName, isWide } = props;

  return (
    <BaseStyledDiv isWide={isWide} className={'chatHeaderRecipient'}>
      <StyledP isWide={isWide}>{facilityName}</StyledP>
    </BaseStyledDiv>
  );
};
